module.exports = __webpack_public_path__ + "img/clock.d3d0aad5.svg";